exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-46731742] {\n  max-width: 300px;\n  flex-grow: 1;\n  height: 100%;\n  margin: 0 auto;\n}\n.card-body[data-v-46731742] {\n  display: flex;\n  flex-flow: column;\n}\n.card[data-v-46731742]:hover {\n  transform: scale(1.02);\n}\n.image-container[data-v-46731742] {\n  flex: 2;\n  display: flex;\n  align-items: center;\n}\n.product-name[data-v-46731742] {\n  font-size: 1rem;\n  margin-top: 0.5rem;\n}", ""]);

// exports
